import { useWebsite } from 'hooks/website/useWebsite';

import s from './EnergyPreviewImage.module.css';

export const EnergyPreviewImage = () => {
  const {
    home: {
      hero: { image: heroImageSrc },
    },
  } = useWebsite();

  return (
    <div
      role="img"
      title="Energy Image Preview"
      className={s.image}
      style={{
        backgroundImage: `url(${heroImageSrc})`,
      }}
    />
  );
};
